import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { Task } from 'models/Task';
import { ADMIN_ROUTES } from 'constants/routes';
import { Col, Divider, Row, Typography } from 'antd';
import { convertEnumsToReadableStrings } from 'utils/helpers';
import { PriorityBadge, PriorityType, Tag } from 'components';
import { StatusBadge, StatusType } from 'components/common/StatusBadge';
import moment from 'moment/moment';
import styles from '../dashboard.module.scss';

const { Text, Paragraph } = Typography;

interface TaskItemProps {
  task: Task;
  onEntityClick: (type: string, id: string) => string;
}

export const TaskItem = memo(({ task, onEntityClick }: TaskItemProps) => {
  return (
    <Col key={task.id} className={styles.dashboard_task} span={24}>
      <Row justify={'space-between'}>
        <Col span={16}>
          <Link to={`${ADMIN_ROUTES.tasks.view}/${task.id}/general`} target={'_blank'} color={'#E1E4EA'}>
            <Text ellipsis={{ tooltip: true }} underline>
              {task.summary}
            </Text>
          </Link>
          <Paragraph className={'light-grey font-size-12'}>ID: {task.uuid}</Paragraph>
        </Col>
        <Col>{task.status ? <StatusBadge type={task.status as StatusType} /> : ''}</Col>
        <Col className={'margin-b-20'} span={24}>
          <Divider />
        </Col>
      </Row>
      <Row className={'margin-b-16'} justify={'space-between'} wrap={false}>
        <Col>
          <Text type={'secondary'}>Due Date</Text>
        </Col>
        <Col>
          <Row gutter={8} wrap={false}>
            <Col>
              <Text type={'secondary'}>{moment(task.dueDate).format('DD.MM.YYYY HH:mm')}</Text>
            </Col>
            <Col style={{ marginTop: -4 }}>
              <PriorityBadge type={task.priorityLevel as PriorityType} />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className={'margin-b-16'} justify={'space-between'} wrap={false}>
        <Col>
          <Text type={'secondary'}>Entity</Text>
        </Col>
        <Col>
          <Link to={onEntityClick(task.entityType, task.entityId)} target={'_blank'} color={'#E1E4EA'}>
            <Tag className={styles.entity_tag} color={'#E1E4EA'}>
              <Text className={'font-size-12'} ellipsis={{ tooltip: true }} underline>
                {`${convertEnumsToReadableStrings(task.entityType)}:${task?.entityValue || task?.entityUuid || ''}`}
              </Text>
            </Tag>
          </Link>
        </Col>
      </Row>
      <Row className={'margin-b-16'} justify={'space-between'} wrap={false}>
        <Col>
          <Text className={'light-grey'}>
            {task._createdBy?.firstName || ''} {task._createdBy?.lastName || ''}
          </Text>
        </Col>
        <Col>
          <Text className={'light-grey'}>{moment(task.createDate).format('DD.MM.YYYY HH:mm')}</Text>
        </Col>
      </Row>
    </Col>
  );
});
